// extracted by mini-css-extract-plugin
module.exports = {"container":"stats_container_2-fDS","stat":"stats_stat_2O-lq","label":"stats_label_3W_XT","value":"stats_value_3jxZs","val":"stats_val_1HGbM","slash":"stats_slash_39Zmi"};